export * from "./types";
import slice from "./Slice";
export const { setResponseOfInviteValidateFalse, setResponseOfInviteChangePhoneNumberFalse, resetphoneNumberVarificationAction, resetChangePasswordAction, setUserNameAndDOB, setMobileNumber, setVarificationCode, setPasswords, setPatientDetails, holdMedicalConditionAction, holdDataAddressAction, resetCallPreferenceAction } = slice.actions;
